// Nomes legíveis para áreas, ações e campos dos logs.

export const AREAS_LOG = {
  payables: "Contas a pagar",
  receivables: "Contas a receber",
  purchases: "Pedidos de compra",
  sales: "Pedidos de venda",
  "purchases-warehouse": "Pedidos do almoxarifado",
  "batch-of-settlements": "Lotes de baixa",
  "lancamentos-bancarios": "Lançamentos bancários",
  "fechamento-financeiro": "Fechamento do financeiro",
  accounts: "Contas bancárias",
  empresas: "Empresas",
  suppliers: "Fornecedores",
  customers: "Clientes",
  "shipping-companies": "Transportadoras",
  products: "Produtos",
  "product-groups": "Grupos de produto",
  users: "Usuários",
  permissions: "Permissões",
  agents: "Agenciadores",
  "account-groups": "Centros de custo",
  "sub-group-accounts": "Naturezas de lançamento",
  "payment-methods": "Formas de pagamento",
  warehouses: "Almoxarifados",
  receiveds: "Recebimentos",
  aplicacao: "Aplicação",
  devolucao: "Devolução",
};

export const ACOES_LOG = {
  cria: "Criou",
  edita: "Alterou",
  exclui: "Excluiu",
  parcela: "Parcelou",
  visualiza: "Visualizou",
};

const CAMPOS = {
  valor: "Valor",
  status: "Status",
  descricao: "Descrição",
  dataPagamento: "Data de pagamento",
  dataVencimento: "Vencimento",
  dataPedido: "Data do pedido",
  account: "Conta bancária",
  supplier: "Fornecedor",
  customer: "Cliente",
  paymentMethod: "Forma de pagamento",
  accountGroup: "Centro de custo",
  accountSubGroup: "Natureza",
  observacoes: "Observações",
  partidaContabil: "Partida contábil",
  prazoPagamento: "Prazo",
  purchase: "Pedido de compra",
  sale: "Pedido de venda",
  numPedido: "Nº do pedido",
  products: "Produtos",
  produtos: "Produtos",
  contas: "Contas",
  payables: "Contas a pagar",
  receivables: "Contas a receber",
  parcelas: "Parcelas",
  nome: "Nome",
  razaoSocial: "Razão social",
  nomeFantasia: "Nome fantasia",
  data: "Data",
  tipo: "Tipo",
  historico: "Histórico",
  de: "De",
  para: "Para",
};

export const rotuloCampo = (campo) => CAMPOS[campo] || campo;

const STATUS = {
  A: "Aberto",
  T: "Atrasado",
  P: "Pago",
  C: "Cancelado",
  D: "Pendente",
  R: "Parcelada",
};

export const valorLog = (campo, valor) => {
  if (valor === null || valor === undefined || valor === "") return "—";
  if (campo === "status" && STATUS[valor]) return STATUS[valor];
  if (typeof valor === "string" && /^\d{4}-\d{2}-\d{2}/.test(valor)) {
    return valor.slice(0, 10).split("-").reverse().join("/");
  }
  if (typeof valor === "object") return JSON.stringify(valor);
  return String(valor);
};

// Alterações de um log: formato novo direto; no antigo (changedData), só os
// campos que vieram como { oldValue, newValue } e de fato mudaram.
export const alteracoesDoLog = (log) => {
  if (log?.alteracoes?.length) return log.alteracoes;
  const dados = log?.changedData;
  if (!dados || typeof dados !== "object") return [];
  return Object.entries(dados)
    .filter(
      ([campo, v]) =>
        !campo.startsWith("_") &&
        v &&
        typeof v === "object" &&
        "oldValue" in v &&
        "newValue" in v &&
        JSON.stringify(v.oldValue) !== JSON.stringify(v.newValue) &&
        typeof v.oldValue !== "object" &&
        typeof v.newValue !== "object"
    )
    .map(([campo, v]) => ({ campo, de: v.oldValue, para: v.newValue }));
};
